// src/AudioSpectrum/effects/stackedBars.js

export const drawStackedBars = (ctx, frequencyData, width, height) => {
  const barCount = Math.min(frequencyData.length / 4, 32);
  const barWidth = width / barCount;
  const stackHeight = 4;
  
  ctx.clearRect(0, 0, width, height);
  
  for (let i = 0; i < barCount; i++) {
    const value = frequencyData[i];
    const stacks = Math.floor((value / 255) * (height / stackHeight));
    
    for (let j = 0; j < stacks; j++) {
      const alpha = 1 - (j / stacks) * 0.7;
      ctx.fillStyle = `rgba(76, 175, 80, ${alpha})`;
      ctx.fillRect(
        i * barWidth, 
        height - (j + 1) * stackHeight, 
        barWidth - 2, 
        stackHeight - 1
      );
    }
  }
};